import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { ContactForm } from "../components/home/ContactForm";
import { ClientsMarquee } from "../components/shared/ClientsMarquee";
import { CorporateHero } from "../components/corporate/CorporateHero";
import { Portfolio } from "../components/shared/Portfolio";
import { corporateCases } from "../content/cases";
import { CorporateOffer } from "../components/corporate/CorporateOffer";
import { CorporateProcess } from "../components/corporate/CorporateProcess";
import { EcomTech } from "../components/ecom/EcomTech";
import { Reviews } from "../components/shared/Reviews";
import { Team } from "../components/shared/Team";
import { Faq } from "../components/shared/Faq";
import { buildMeta, breadcrumbJsonLd, serviceJsonLd, SITE_URL } from "../lib/site";

const title = "Разработка корпоративного сайта под ключ — стоимость | HAY.agency";
const description =
  "Разрабатываем корпоративные сайты под ключ: аналитика, структура, UX/UI, контент, CMS, интеграции и SEO. В том числе проекты на 1С-Битрикс.";

const faqItems = [
  {
    q: "Сколько стоит корпоративный сайт?",
    a: "От 350 000 ₽. Итоговая стоимость рассчитывается после определения структуры, функциональности, CMS и интеграций.",
  },
  {
    q: "Сколько времени занимает разработка?",
    a: "От 1,5 месяцев. Срок зависит от объёма структуры, количества интеграций и скорости согласования контента.",
  },
  {
    q: "На какой CMS вы разрабатываете?",
    a: "Подбираем CMS под задачи проекта: 1С-Битрикс, а также решения на собственном стеке для нестандартной логики.",
  },
  {
    q: "Разрабатываете ли сайты на 1С-Битрикс?",
    a: "Да. 1С-Битрикс — одна из основных CMS в нашем стеке. Это система управления сайтом, её не следует путать с CRM Битрикс24.",
  },
  {
    q: "Входит ли SEO в разработку?",
    a: "Базовая SEO-основа входит: структура, метатеги, скорость, микроразметка и корректная индексация. Дальнейшее продвижение — отдельная услуга.",
  },
];

export const Route = createFileRoute("/corporate")({
  head: () => ({
    ...buildMeta({ title, description, path: "/corporate", image: `${SITE_URL}/og/services/corporate.webp`, imageWidth: 1200, imageHeight: 630, imageAlt: "Разработка корпоративных сайтов — HAY.agency", locale: "ru_RU" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": `${SITE_URL}/corporate#webpage`,
              url: `${SITE_URL}/corporate`,
              name: title,
              description,
              inLanguage: "ru-RU",
              isPartOf: { "@id": `${SITE_URL}/#website` },
              breadcrumb: { "@id": `${SITE_URL}/corporate#breadcrumbs` },
              mainEntity: { "@id": `${SITE_URL}/corporate#service` },
            },
            serviceJsonLd({
              name: "Разработка корпоративных сайтов",
              description,
              path: "/corporate",
              id: `${SITE_URL}/corporate#service`,
              serviceType: "Разработка корпоративных сайтов",
              providerId: `${SITE_URL}/#organization`,
              inGraph: true,
            }),
            breadcrumbJsonLd(
              [
                ["Главная", "/"],
                ["Корпоративные сайты", "/corporate"],
              ],
              { id: `${SITE_URL}/corporate#breadcrumbs`, inGraph: true },
            ),
            {
              "@type": "FAQPage",
              "@id": `${SITE_URL}/corporate#faq`,
              mainEntity: faqItems.map((item) => ({
                "@type": "Question",
                name: item.q,
                acceptedAnswer: { "@type": "Answer", text: item.a },
              })),
            },
          ],
        }),
      },
    ],
  }),
  component: CorporatePage,
});

function CorporatePage() {
  return (
    <ServicePageLayout breadcrumb="Корпоративные сайты" jsonLd={false}>
      <CorporateHero />
      <div className="pb-10 lg:pb-[74px]">
        <ClientsMarquee bare />
      </div>
      <Portfolio
        items={corporateCases}
        lead="Мы не за количество, а за качество. Работаем с ограниченным числом клиентов — благодаря этому вам будет максимально удобно, как будто мы часть вашей команды."
      />
      <CorporateOffer />
      <CorporateProcess />
      <EcomTech />
      <Reviews />
      <Team />
      <Faq
        compact
        title="Частые вопросы о разработке корпоративного сайта"
        lead="Стоимость, сроки, CMS и SEO — коротко."
        items={faqItems}
      />
      <ContactForm />
    </ServicePageLayout>
  );
}
